/**
 * @fileoverview PUT handler for the "/generative_ai/agent_update_archived_state" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiAgentUpdateArchivedStateCacheKeys } from "./constants";
import type {
  PutGenerativeAiAgentUpdateArchivedStateProps,
  GenerativeAiAgentUpdateArchivedStateResult,
} from "./types";

export const putGenerativeAiAgentUpdateArchivedState = reactQueryMutationAdapter(
  generativeAiAgentUpdateArchivedStateCacheKeys,
  (props: PutGenerativeAiAgentUpdateArchivedStateProps): Promise<GenerativeAiAgentUpdateArchivedStateResult> => {
    return fetch("/generative_ai/agent_update_archived_state", "PUT", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
